import React from "react";
import { useSelector, useDispatch } from "react-redux";
import LogoPP from "../common/LogoPP";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Button } from "cxa-components";
import messages from "components/messagesDescription";
import FooterLogoPP from "../common/FooterLogoPP";
import moment from "moment";
import { updateUserRole, setUserRole } from "../../actions/loginActions";

const Footer = ({ intl }) => (
  <footer className="footer-wrapper">
    <div className="o-wrapper">
      <div className="footer">
        <div className="footer__copy">
          <FooterLogoPP aria-hidden={true} className="footer__logo" />{" "}
          <span role="img" aria-label="Copyright">
            {"\u00A9"}
          </span>
          {` ${moment().format("Y")} `}
          {intl.formatMessage(messages.businessNameDescription)}
        </div>
        <nav className="footer__nav">
          <a
            className="footer__nav-item"
            href={intl.formatMessage(messages.termsLink)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.termsDescription} />
          </a>
          <a
            className="footer__nav-item"
            href={intl.formatMessage(messages.privacyLink)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.privacyDescription} />
          </a>
          <Link className="footer__nav-item" to="/contact">
            <FormattedMessage {...messages.contactDescription} />
          </Link>
        </nav>
      </div>
    </div>
  </footer>
);

const RoleSelectionPage = ({ intl, push }) => {
  const loginState = useSelector(state => state.login);
  const dispatch = useDispatch();

  const setSelectedRole = user => {
    dispatch(setUserRole(user));
  };
  const updateRole = () => {
    dispatch(updateUserRole(loginState.selectedRole));
    push("/");
  };
  return (
    <div style={{ textAlign: "center" }}>
      <header style={{ margin: "10px" }}>
        <LogoPP width={240} />
      </header>
      <div className="o-wrapper-pp role-selection-page-container">
        <div className="role-selection-container">
          <h4>
            <strong>{intl.formatMessage(messages.roleSelection.selectRoleLabel)}</strong>
          </h4>
          <p>{intl.formatMessage(messages.roleSelection.selectRoleNote1)}</p>
          <p>{intl.formatMessage(messages.roleSelection.selectRoleNote2)}</p>
          <div className="">
            <Button
              className={
                loginState.selectedRole === "Employee"
                  ? "button--primary active-role-btn"
                  : "button--secondary inactive-role-btn"
              }
              onClick={() => setSelectedRole("Employee")}
            >
              <strong>{intl.formatMessage(messages.roleSelection.staffRole)}</strong>
            </Button>
            <Button
              className={
                loginState.selectedRole === "HRAdmin"
                  ? "button--primary active-role-btn"
                  : "button--secondary inactive-role-btn"
              }
              onClick={() => setSelectedRole("HRAdmin")}
            >
              <strong>{intl.formatMessage(messages.roleSelection.hrRole)}</strong>
            </Button>
          </div>
          <div className="button-container">
            <Button primary onClick={updateRole}>
              {intl.formatMessage(messages.roleSelection.continueButton)}
            </Button>
          </div>
        </div>
      </div>
      <Footer intl={intl} />
    </div>
  );
};

RoleSelectionPage.propTypes = {
  intl: intlShape.isRequired,
  push: PropTypes.func,
};
Footer.propTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(RoleSelectionPage));



// WEBPACK FOOTER //
// ./components/login/RoleSelectionPage.jsx